module.exports = __webpack_public_path__ + "img/fig04.c4628caf.jpg";